import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { IconType, ThemeType } from '../../../@types';
import { AppContext } from '../../../context/app';
import { PrintContext } from '../../../context/print';
import { useClearParamsAndNavigate } from '../../../hooks/useClearParamsAndNavigate';
import { useNavigationManager } from '../../../hooks/useNavigationManager';
import { useNetworkManager } from '../../../hooks/useNetworkManager';
import AzureDirectionsList from '../azureDirectionsList/azureDirectionsList';
import ButtonStyled from '../button/Button';
import Icon from '../icon/Icon';
import { LegTwoVisualSteps } from '../LegTwoVisualSteps/LegTwoVisualSteps';
import NavigationDetailsCard from '../navigationDetailsCard/NavigationDetailsCard';
import styles from './modalPrintDirections.module.scss';

const ModalPrintDirections: React.FC = () => {
  const { t } = useTranslation('common');
  const { showPrintDirectionView, setShowPrintDirectionView, directions } =
    useContext(AppContext);
  const { legTwoRoute } = useNavigationManager();
  const { siteLogo, siteName } = useNetworkManager();
  const { setPrintDialogOpen } = useContext(PrintContext);
  const clearParamsAndNavigate = useClearParamsAndNavigate();

  const handlePrint = () => {
    setPrintDialogOpen(true);
    setTimeout(() => window.print(), 200);
  };
  const handleBackClick = () => {
    clearParamsAndNavigate(['printMode']);
    setShowPrintDirectionView(false);
  };

  return showPrintDirectionView ? (
    <div className={styles.body}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.menu}>
            <ButtonStyled
              onClick={() => handleBackClick()}
              variant={'outlined'}
              uppercase
            >
              <>
                <Icon theme={ThemeType.PRIMARY} icon={IconType.LEFT} />{' '}
                {t('campusNavigation.print.backButton')}
              </>
            </ButtonStyled>
            <ButtonStyled onClick={handlePrint} uppercase>
              {t('campusNavigation.print.printButton')}
            </ButtonStyled>
          </div>
        </header>
        <main className={styles.main}>
          <img
            src={siteLogo}
            alt={siteName}
            title={siteName}
            className={styles.logo}
          />
          <NavigationDetailsCard title={t('campusNavigation.print.title')} />
          {directions && <AzureDirectionsList collapsed={false} printMode />}
          {legTwoRoute && <LegTwoVisualSteps />}
        </main>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default ModalPrintDirections;
